export default "__VITE_ASSET__BLTvgvAz__"